/// <reference path="../../apps/typings/handlebars.d.ts" />
/// <reference path="../../apps/typings/customTds.d.ts" />
import { AppUtils } from '../../shared/utils/index';


export namespace View {
	const HbOperators = {
		eq: function (v1: any, v2: any): boolean {
			return v1 === v2;
		},
		ne: function (v1: any, v2: any): boolean {
			return v1 !== v2;
		},
		lt: function (v1: any, v2: any): boolean {
			return v1 < v2;
		},
		gt: function (v1: any, v2: any): boolean {
			return v1 > v2;
		},
		lte: function (v1: any, v2: any): boolean {
			return v1 <= v2;
		},
		gte: function (v1: any, v2: any): boolean {
			return v1 >= v2;
		},
		and: function (...args: any[]): boolean {
			return Array.prototype.slice.call(args).every(Boolean);
		},
		or: function (...args: any[]): boolean {
			return Array.prototype.slice.call(args, 0, -1).some(Boolean);
		}
	};
	const HbHelpers = {
		contains_any: function (this: any, v1: any, v2: any, v3: any, array: any[], options: Handlebars.HelperOptions): string {
			const values = (array instanceof Array) ? array : [array];
			if (values.indexOf(v1) > -1 || values.indexOf(v2) > -1 || values.indexOf(v3) > -1) {
				return options.fn(this);
			}
			return "";
		},
		contains: function (this: any, value: any, array: any[], options: Handlebars.HelperOptions): string {
			const values = (array instanceof Array) ? array : [array];
			return (values.indexOf(value) > -1) ? options.fn(this) : "";
		},
		contains_prop: function (
			conditions: Record<string, any>,
			array: any[],
			options: Handlebars.HelperOptions
		): string {
			const values = Array.isArray(array) ? array : [array];

			const found = values.some(item =>
				item &&
				typeof item === 'object' &&
				// eslint-disable-next-line eqeqeq
				Object.entries(conditions).every(([key, val]) => item[key] == val) // lose Vergleich erlaubt "14" == 14 //NOSONAR
			);

			return found ? options.fn(this) : options.inverse(this);
		},
		object: function (...args: any[]): Record<string, any> {
			args.pop(); // Letztes Argument ist Handlebars-internes options-Objekt

			const obj: Record<string, any> = {};
			for (let i = 0; i < args.length; i += 2) {
				obj[args[i]] = args[i + 1];
			}
			return obj;
		},
		/**
		 * @deprecated use eq operator
		 */
		if_eq: function (this: any, a: any, b: any, opts: Handlebars.HelperOptions): string {
			// eslint-disable-next-line eqeqeq
			if (a == b) { //NOSONAR // no type comparison on "any"
				return opts.fn(this);
			} else {
				return opts.inverse(this);
			}
		},
		/**
		 * @deprecated use not, eq operators
		 */
		if_not_eq: function (this: any, a: any, b: any, opts: Handlebars.HelperOptions): string {
			// eslint-disable-next-line eqeqeq
			if (a == b) { //NOSONAR // no type comparison on "any"
				return opts.inverse(this);
			} else {
				return opts.fn(this);
			}
		},
		if_all: function (this: any, ...args: any[]): string {
			const argsArr = [].slice.apply(args);
			const opts: Handlebars.HelperOptions = argsArr.pop();
			let fn = opts.fn;
			// eslint-disable-next-line prefer-const
			for (let arg of argsArr) { //NOSONAR
				if (arg) {
					continue;
				}
				fn = opts.inverse;
				break;
			}
			return fn(this);
		},
		if_any: function (this: any, ...args: any[]): string {
			const argsArr = [].slice.apply(args);
			const opts: Handlebars.HelperOptions = argsArr.pop();
			let fn = opts.inverse;
			// eslint-disable-next-line prefer-const
			for (let arg of argsArr) { //NOSONAR
				if (arg) {
					fn = opts.fn;
					break;
				}
			}
			return fn(this);
		},
		if_any_equals: function (this: any, ...args: any[]): string {
			const argsArr = [].slice.apply(args);
			const opts: Handlebars.HelperOptions = argsArr.pop();
			const equalsValue = argsArr.shift();
			let fn = opts.inverse;
			// eslint-disable-next-line prefer-const
			for (let arg of argsArr) { //NOSONAR
				// eslint-disable-next-line eqeqeq
				if (arg == equalsValue) { //NOSONAR // no type comparison on "any"
					fn = opts.fn;
					break;
				}
			}
			return fn(this);
		}
	};
	const HbFormatters = {
		inc: function (value: number): number {
			return Number(value) + 1;
		},
		toUpperCase: function (str: string): string {
			if (str) {
				return str.toUpperCase();
			}
			return str;
		},
		toLowerCase: function (str: string): string {
			if (str) {
				return str.toLowerCase();
			}
			return str;
		},
		obfuscateIban: function (iban: string, options?: Handlebars.HelperOptions): string {
			if (!iban) {
				return '';
			}
			if (options && options.hash && options.hash.split) {
				const pattern = new RegExp(`(.{${options.hash.split}})`, "g");
				return `${iban.substring(0, 2)}xxxxxxxxxxxxxxxxxxxx${iban.substring(iban.length - 5)}`.replace(pattern, '$1 ');
			}
			return `${iban.substring(0, 2)}xxxxxxxxxxxxxxxxxxxx${iban.substring(iban.length - 5)}`;
		},
		formatCurrency: function (value: number, options: Handlebars.HelperOptions): string {
			let decimal = 2, seperator = '', returnValue = '';
			const n = value || 0;
			if (options && options.hash) {
				if (options.hash.decimal) {
					decimal = options.hash.decimal;
				}
				if (options.hash.seperator) {
					seperator = options.hash.seperator;
				}
				if (options.hash.replace) {
					returnValue = $.number(n, decimal, ',', seperator);
				}
				else {
					returnValue = $.number(n, decimal, ',', seperator).replace('.', ',');
				}
			}
			return returnValue;
		},
		formatDecimal: function (value: number): string {
			if (isNaN(value) || !value) {
				return '';
			}
			return value.toString().replace('.', ',');
		},
		formatDate: function (value: string, options: Handlebars.HelperOptions): string {
			if (!value) {
				return value;
			}
			return moment(value).format(options.hash.format || 'DD.MM.YYYY');
		},
		formatTelephoneNumber: function (value: any): string {
			if (!value) {
				return value;
			}
			return `${value.Prefix} / ${value.Suffix}`;
		}
	};

	let _helpersDone = false; //NOSONAR // namespace global var

	/**
	 * renderTemplate.
	 *
	 * the function is responsible to render the current template with the data provided
	 * by the application options and the json configuration of the service-api.
	 * The function maps double curly brackets with a key to the data parameter.
	 *
	 * @param template - the html template with optional handlebars variables.
	 * @param data - the data to be accessable by handlebars.
	 * @param dest - the context to render the template.
	 */
	export function renderTemplate(template: string, data: { [key: string]: any }, dest: JQuery | HTMLElement, afterRender: () => void): void {
		AppUtils.View.registerHelpers();

		const compiledTemplate = Handlebars.compile(template);
		$(dest).html(compiledTemplate(data, {
			allowProtoPropertiesByDefault: true,
			allowProtoMethodsByDefault: true
		}));
		afterRender();
	}

	export function startLoader(loaderId?: string, loaderCheckTimeout?: number, loaderHintext?: string, loaderHintextTimeout?: number): void {
		T.Utils.View.startLoader(loaderId, loaderCheckTimeout, loaderHintext, loaderHintextTimeout);
	}

	export function stopLoader(loaderId?: string): void {
		T.Utils.View.stopAllLoader(loaderId);
	}

	/**
	 * Register Template Helpers
	 *
	 */
	export function registerHelpers(): void {
		if (_helpersDone) {
			return;
		}
		_helpersDone = true;

		Handlebars.registerHelper(HbOperators);
		Handlebars.registerHelper(HbHelpers);
		Handlebars.registerHelper(HbFormatters);
	}

	/* istanbul ignore next: wrapper function */
	export function initFormElements(): void {
		S.Utils.Form.init();
		S.Utils.Clone.init();
		T.Utils.Helper.updateUrlsWithCampaignParam();
		T.Utils.Helper.appendDeviceUrlParamToAllLinksInContext($('body'));
	}

	/* istanbul ignore next: requires viewport */
	export function scrollTop(): void {
		$(window).scrollTop(0);
	}

	/* istanbul ignore next: requires viewport */
	export function scrollTo(top: number, duration = 800): void {
		$('html, body').animate({
			scrollTop: top
		}, duration);
	}

	/* istanbul ignore next: requires viewport */
	export function scrollToElement(element: JQuery.Selector | JQuery | HTMLElement, footerHeight = 100, duration = 1000): void {
		const offset = $(element as any).offset();
		if (offset) {
			AppUtils.View.scrollTo(offset.top - footerHeight, duration);
		}
	}

	/**
	 * Jumping to anchor doesn't always work on initial page load, method for calling in afterRenderApp
	 */
	/* istanbul ignore next: requires viewport */
	export function jumpToAnchor(): void {
		if (window.location.hash) {
			const $anchor = $(window.location.hash).first();
			if ($anchor && $anchor.length) {
				window.scrollTo(0, $anchor.position().top);
			}
		}
	}

	export function enableOrDisableClickEvent(className: string, enable = true, position?: number): void {
		const element = document.querySelectorAll(className)[position || 0] as HTMLElement;
		if (enable) {
			// enable events
			element.style.pointerEvents = 'auto';
		} else {
			// disable events
			element.style.pointerEvents = 'none';
		}
	}

	export function displayDialog(element: JQuery | HTMLElement, message?: string, isModal = false): void {
		const $dialog = $(element);
		if (message) {
			$dialog.find('.error-msg').html(message);
		}
		$.magnificPopup.open({
			items: {
				src: $dialog
			},
			fixedContentPos: true,
			modal: isModal,
			callbacks: {
				beforeOpen: function () {
					// setup classes
					$dialog.addClass("ll-lightbox-inner");
					this.st.mainClass = "mfp-zoom-in l-lightbox";
				}
			}
		});
		$dialog.find('.js-close-lightbox').on('click', function () {
			$.magnificPopup.close();
		});
	}

	export function getMetaValueByKey(key: string): string {
		return $(`meta[data-key="${key}"]`).attr('data-value');
	}

	export function hideElement(element: JQuery, hide = true): void {
		element.toggleClass('h-hidden', hide);
	}

	export function renderPdfFileLink(anchorElement: JQuery, filename: string, pdfFile: string): void {
		const filenameWithPdf = filename ? (filename.toLowerCase().endsWith(".pdf") ? filename : `${filename}.pdf`) : "SepaMandat.pdf";
		// Internet explorer workaround for dataUri's
		if (navigator.msSaveBlob) {
			anchorElement.on('click', /* istanbul ignore next: not waitable */(e: JQuery.Event) => {
				e.preventDefault();
				window.navigator.msSaveBlob?.(AppUtils.Helper.getPdfBlobFromDataUri(pdfFile), filenameWithPdf);
			});
		} else {
			// Safari doesn't support 'download' attributes, so he's going for the dataUri link
			anchorElement.attr('href', `data:application/pdf;base64,${pdfFile}`);
			anchorElement.attr('download', filenameWithPdf);
		}
	}

	export function appendCampaignUrlParam($ctx: JQuery): void {
		const campaignIds = T.Utils.Helper.getCampaignUrlParams();
		const telljaIds = T.Utils.Helper.getTelljaIdUrlParams();
		if (campaignIds.length || telljaIds.length) {
			$ctx.find("a[href!=''][href]").on("click", (e) => {
				let targetLink;
				if (e.target && e.target.tagName === "A") {
					targetLink = e.target;
				} else if (e.target && e.target.closest("a")) {
					targetLink = e.target.closest("a");
				}

				if (targetLink) {
					const hrefLink = new URL(targetLink.getAttribute("href"), window.location.href).toString();

					if (hrefLink &&
						!T.Utils.Helper.isMediaUrl(hrefLink) &&
						!T.Utils.Helper.isExternalUrl(hrefLink)) {
						const newUrl = T.Utils.Helper.getUrlWithIdParam(hrefLink, campaignIds, telljaIds);
						if (newUrl !== hrefLink) {
							targetLink.setAttribute("href", newUrl);
						}
					}
				}
			});
		}
	}
}
